import React from "react";
import SEO from "./SEO";

const RedirectBlog = () => {
    React.useEffect(() => {
      window.location.replace('https://oceanbeachbrands.medium.com/')
    }, [])

    return (
      <SEO
        title="Ocean Beach Brands Blog"
        description="Redirecting to Ocean Beach Brands articles on Medium."
        canonical="https://oceanbeachbrands.com/blog"
        robots="noindex, follow"
      />
    );
  }

export default RedirectBlog;
